<template>
  <div class="" >
    <section class=" container-fluid flex flex-col items-center justify-center align-center p-3 w-full">
      <h2 class="text-4xl font-semibold mt-20 text-center">Advanced Statistics</h2> 
      <p class="text-xl text-gray-800 text-center md:tracking-wide mt-3">Track how your links are performing across the web with our Advanced statistics dashboard</p>
      <Cards/>
    </section>
    
  </div>
</template>

<script>

    import Cards from './Cards';

export default {
  name: "Statistics",
    components: {
        Cards,
    },
};
</script>

<style scoped>
section{
    margin-top: 100px;
    background-color: grey;
    width: 100%;
}
</style>
